import EventForm from "./eventForm";
import { authFetch } from "../../utils/api";


//CRÉATION D'UN ÉVÈNEMENT
function CreateEvents() {

  const createEvent = async (eventData) => {
    const response = await authFetch(`/eventRoute/createEvent`, {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(eventData),
    });
    return response.json();
  };

  return (
    <div className="bo-page surface">
      <h2 className="title-xl bo-page_title">Créer un événement</h2>
      <p className="bo-page_intro">Les champs marqués d’un astérisque (<span className="field_required">*</span>) sont obligatoires.</p>
      <EventForm onSubmit={createEvent} submitLabel="Créer l’événement" resetOnSuccess />
    </div>
  )
};

export default CreateEvents;
